import { render, staticRenderFns } from "./TransactionVolumes.vue?vue&type=template&id=2b17ed16&scoped=true&"
import script from "./TransactionVolumes.vue?vue&type=script&lang=js&"
export * from "./TransactionVolumes.vue?vue&type=script&lang=js&"
import style0 from "./TransactionVolumes.vue?vue&type=style&index=0&id=2b17ed16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17ed16",
  null
  
)

export default component.exports